function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { memo, useRef } from "react";
import { useIsomorphicLayoutEffect } from "ahooks";
import { useSpring, animated } from "@react-spring/web";
import { rubberbandIfOutOfBounds } from "../../utils/rubberband";
import { useDrag, useWheel } from "@use-gesture/react";
import isEqual from "lodash/isEqual";
import { measureCSSLength } from "../../utils/measure-css-length";
import { bound } from "../../utils/bound";
import { supportsPassive } from "../../utils/supports-passive";
var classPrefix = "tc-picker-view";
export var Wheel = /*#__PURE__*/memo(function (props) {
  var value = props.value,
    column = props.column,
    renderLabel = props.renderLabel;
  var onSelect = function onSelect(val) {
    props.onSelect(val, props.index);
  };
  var _useSpring = useSpring(function () {
      return {
        from: {
          y: 0
        },
        config: {
          tension: 400,
          mass: 0.8
        }
      };
    }),
    _useSpring2 = _slicedToArray(_useSpring, 2),
    y = _useSpring2[0].y,
    api = _useSpring2[1];
  var draggingRef = useRef(false);
  var rootRef = useRef(null);
  var itemHeightMeasureRef = useRef(null);
  var itemHeight = useRef(34);
  useIsomorphicLayoutEffect(function () {
    var itemHeightMeasure = itemHeightMeasureRef.current;
    if (!itemHeightMeasure) return;
    itemHeight.current = measureCSSLength(window.getComputedStyle(itemHeightMeasure).getPropertyValue("height"));
  });
  useIsomorphicLayoutEffect(function () {
    if (draggingRef.current) return;
    if (value === null) return;
    var targetIndex = column.findIndex(function (item) {
      return item.value === value;
    });
    if (targetIndex < 0) return;
    var finalPosition = targetIndex * -itemHeight.current;
    api.start({
      y: finalPosition,
      immediate: y.goal !== finalPosition
    });
  }, [value, column]);
  useIsomorphicLayoutEffect(function () {
    if (column.length === 0) {
      if (value !== null) {
        onSelect(null);
      }
    } else {
      if (!column.some(function (item) {
        return item.value === value;
      })) {
        var firstItem = column[0];
        onSelect(firstItem.value);
      }
    }
  }, [column, value]);
  function scrollSelect(index) {
    var finalPosition = index * -itemHeight.current;
    api.start({
      y: finalPosition
    });
    var item = column[index];
    if (!item) return;
    onSelect(item.value);
  }
  var handleDrag = function handleDrag(state) {
    draggingRef.current = true;
    var min = -((column.length - 1) * itemHeight.current);
    var max = 0;
    if (state.last) {
      draggingRef.current = false;
      var position = state.offset[1] + state.velocity[1] * state.direction[1] * 50;
      var targetIndex = min < max ? -Math.round(bound(position, min, max) / itemHeight.current) : 0;
      scrollSelect(targetIndex);
    } else {
      var _position = state.offset[1];
      api.start({
        y: rubberbandIfOutOfBounds(_position, min, max, itemHeight.current * 50, 0.2)
      });
    }
  };
  useDrag(function (state) {
    state.event.stopPropagation();
    handleDrag(state);
  }, {
    axis: "y",
    from: function from() {
      return [0, y.get()];
    },
    filterTaps: true,
    pointer: {
      touch: true
    },
    target: rootRef
  });
  useWheel(function (state) {
    state.event.stopPropagation();
    handleDrag(state);
  }, {
    axis: "y",
    from: function from() {
      return [0, y.get()];
    },
    preventDefault: true,
    target: props.mouseWheel ? rootRef : undefined,
    eventOptions: supportsPassive ? {
      passive: false
    } : false
  });
  var selectedIndex = null;
  function renderAccessible() {
    if (selectedIndex === null) {
      return null;
    }
    var current = column[selectedIndex];
    var previousIndex = selectedIndex - 1;
    var nextIndex = selectedIndex + 1;
    var previous = column[previousIndex];
    var next = column[nextIndex];
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(classPrefix, "-column-accessible")
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(classPrefix, "-column-accessible-current"),
      role: 'button',
      "aria-label": current ? "\u5F53\u524D\u9009\u62E9\u7684\u662F\uFF1A".concat(current.label) : "当前未选择"
    }), /*#__PURE__*/React.createElement("div", {
      className: "".concat(classPrefix, "-column-accessible-button"),
      onClick: function onClick() {
        if (!previous) return;
        scrollSelect(previousIndex);
      },
      role: previous ? "button" : "text",
      "aria-label": !previous ? "没有上一项" : "\u9009\u62E9\u4E0A\u4E00\u9879\uFF1A".concat(previous.label)
    }), /*#__PURE__*/React.createElement("div", {
      className: "".concat(classPrefix, "-column-accessible-button"),
      onClick: function onClick() {
        if (!next) return;
        scrollSelect(nextIndex);
      },
      role: next ? "button" : "text",
      "aria-label": !next ? "没有下一项" : "\u9009\u62E9\u4E0B\u4E00\u9879\uFF1A".concat(next.label)
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-column")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-item-height-measure"),
    ref: itemHeightMeasureRef
  }), /*#__PURE__*/React.createElement(animated.div, {
    ref: rootRef,
    style: {
      translateY: y
    },
    className: "".concat(classPrefix, "-column-wheel"),
    "aria-hidden": true
  }, column.map(function (item, index) {
    var _a;
    var selected = props.value === item.value;
    if (selected) selectedIndex = index;
    function handleClick() {
      draggingRef.current = false;
      scrollSelect(index);
    }
    return /*#__PURE__*/React.createElement("div", {
      key: (_a = item.key) !== null && _a !== void 0 ? _a : item.value,
      "data-selected": item.value === value,
      className: "".concat(classPrefix, "-column-item"),
      onClick: handleClick,
      "aria-hidden": !selected,
      "aria-label": selected ? "active" : ""
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(classPrefix, "-column-item-label")
    }, renderLabel(item)));
  })), renderAccessible());
}, function (prev, next) {
  if (prev.index !== next.index) return false;
  if (prev.value !== next.value) return false;
  if (prev.onSelect !== next.onSelect) return false;
  if (prev.renderLabel !== next.renderLabel) return false;
  if (prev.mouseWheel !== next.mouseWheel) return false;
  if (!isEqual(prev.column, next.column)) {
    return false;
  }
  return true;
});